import type { UpdateUserV7RequestTheme } from '@/api-client/userAndPermission/model';

export const THEME_START_CASE = ['Light', 'Dark'] as const;

export const THEME_MAPPER: Record<(typeof THEME_START_CASE)[number], UpdateUserV7RequestTheme> = {
  Dark: 'dark',
  Light: 'light',
};
